import React, { useState } from "react";
import { Compass, X } from "lucide-react";
import api from "@/lib/api";

// Lightweight contextual feature discovery. Shows once per feature; persists dismissal.
// Never modal spam: render at most one per surface.
export default function FeatureTour({ feature, title, what, why, how, seen = [], onShowMe }) {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed || (seen || []).includes(feature)) return null;

  const ack = (action) => {
    setDismissed(true);
    api.post("/daily/tour", { feature, action }).catch(() => {});
  };

  return (
    <div data-testid={`tour-${feature}`} className="tc-card p-4 border-tc-mastery/30 bg-gradient-to-br from-tc-mastery/10 to-transparent animate-fade-up">
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-start gap-2.5">
          <div className="w-9 h-9 rounded-lg bg-tc-mastery/15 border border-tc-mastery/25 flex items-center justify-center text-tc-mastery shrink-0">
            <Compass className="w-4.5 h-4.5" />
          </div>
          <div>
            <div className="text-[11px] font-mono uppercase tracking-widest text-tc-mastery">New here · {title}</div>
            <p className="text-tc-txt text-sm mt-1"><b>What:</b> {what}</p>
            <p className="text-tc-sub text-sm mt-0.5"><b>Why:</b> {why}</p>
            {how && <p className="text-tc-sub text-sm mt-0.5"><b>How:</b> {how}</p>}
          </div>
        </div>
        <button data-testid={`tour-close-${feature}`} onClick={() => ack("got_it")} className="text-tc-muted hover:text-tc-txt"><X className="w-4 h-4" /></button>
      </div>
      <div className="flex flex-wrap gap-2 mt-3">
        <button data-testid={`tour-gotit-${feature}`} onClick={() => ack("got_it")}
          className="rounded-lg bg-tc-mastery text-tc-bg font-semibold px-4 py-1.5 text-sm">Got it</button>
        {onShowMe && (
          <button data-testid={`tour-showme-${feature}`} onClick={() => { ack("show_me"); onShowMe(); }}
            className="rounded-lg border border-white/15 text-tc-sub px-4 py-1.5 text-sm hover:text-tc-txt">Show me</button>
        )}
        <button data-testid={`tour-dontshow-${feature}`} onClick={() => ack("dont_show")}
          className="rounded-lg border border-transparent text-tc-muted px-3 py-1.5 text-sm hover:text-tc-sub">Don't show again</button>
      </div>
    </div>
  );
}
